import $ from 'jquery'
import 'bootstrap/js/affix'

export default {
  install (Vue) {
    Vue.directive('affix', {
      params: ['offsetTop', 'offsetBottom'],
      bind () {
        $(this.el).affix({
          offset: {
            top: this.params.offsetTop,
            bottom: this.params.offsetBottom
          }
        })
      },
      paramsWatchers: {
        offsetTop (val) {
          this.bind()
        },
        offsetBottom (val) {
          this.bind()
        }
      },
      unbind () {
        $(window).off('.affix')
      }
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/directives/v-affix.js
 **/